import { connect } from 'react-redux';

import { getDashboardFunnelConversionInterval } from '../../../../../reducers/analyticsApp';
import { setConversionInterval } from '../../../../../actions/dashboards/funnels';
import PaneContainer from '../../../../../components/dashboards/cards/builder/funnels/PaneContainer';

const mapStateToProps = (state, { unit }) => ({
  interval: getDashboardFunnelConversionInterval(state, unit.id),
});

const mapDispatchToProps = (dispatch, { unit }) => ({
  onChangeInterval: (interval) => dispatch(setConversionInterval(interval, unit.id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PaneContainer);
